<small class="debug">{{me}}</small>
<!--<div *ngIf="isPlayerAssignable">-->
<div class="itemTableWrap">
    <div [formGroup]="group" floatLabel="never">
        <app-table-list-input #tableList required
                              (update)="onTableListUpdate($event)"
                              [keepTableIds]="false"
                              [cloneVals]="true"
                              [callBackValue]="onCallBackValueTableEvents()"
                              [callBackFaIcon]="onCallBackEventTableFaIcon()"
                              [confirmRemove]="false"
                              [disableDrag]="true"
                              [tableColumns]="tableColumns"
                              [buttonBarClassName]="'playlistButtonBar'"
                              [multiSelect]="false"
                              [rememberSelection]="false"
                              [allowFilter]="true"
                              [buttons]="buttons"
                              [enablePagination]="true"
                              [formControlName]="'tableCatalog'">
        </app-table-list-input>
    </div>
</div>
<br/>
<br/>


<ng-template let-modal #importSchedModal>
    <small class="debug">{{me}}</small>
    <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
        <mat-icon class="moveMatIcon">trending_up</mat-icon>
        <mat-label style="font-size: 0.6em">{{'general.selectSchedules' | transloco}}</mat-label>
        <div class="dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path
                        d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
        <button disabled="{{importCheckboxesModal.selected.length === 0}}" class="insert" mat-raised-button color="warn" (click)="import()">
            <mat-icon>downloading</mat-icon>
            {{'general.insert' | transloco}}
        </button>
    </h1>
    <div mat-dialog-content>
        <br/>
        <br/>
        <div fxLayout="row" fxLayoutAlign="center center">
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (change)="$event ? masterToggle() : null"
                                      [checked]="importCheckboxesModal.hasValue() && isAllSelected()"
                                      [indeterminate]="importCheckboxesModal.hasValue() && !isAllSelected()">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation(); resourceChecked(row.schedule_id)"
                                      (change)="$event ? importCheckboxesModal.toggle(row.schedule_id) : null"
                                      [checked]="importCheckboxesModal.isSelected(row.schedule_id)">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="schedule_name">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'general.name' | transloco}}</th>
                    <td mat-cell *matCellDef="let element">{{element.schedule_name}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <br/>
        <br/>
        <br/>
    </div>
</ng-template>

